import api from "./instance";

export const getHraCategories = (staffId) => api.get(`/staff/allhracat`);

export const getHraSubmissionStatus = (staffId) => api.get(`staff/hra-submission-status`);

export const getHraQuestions = () => api.get("/admin/hra-questions");

export const submitHraAnswers = (payload) => api.post("/staff/submit-hra-answers", payload);

export const getAdminQuestions = () => api.get("/admin/questions");

export const submitQuestionAnswer = (payload) =>
  api.post("/staff/submit-questionanswer", payload);
